/** @format */

import React, { useState, useEffect } from "react";
import useSettings from "stores/settings";
import Modal from "react-awesome-modal";
// import { PhoneNumberValidator, CheckEmail } from "components/Function";
import { BasicAlert } from "components/Alert";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import { projectFirestore } from "components/ProjectFirestore";
import TextMaskCustom from "./profilePhone";
import BankAccountNumber from "./bankAccountNumber";
import { PageTokenCheck } from "function/PageTokenCheck";
import { useRouter } from "next/router";
const PayInfo = () => {
  const settings = useSettings();
  const router = useRouter();
  const [data, setData] = useState();

  /* 로그인 체크 : url 이동 */
  useEffect(() => {
    PageTokenCheck(settings, router);
  }, []);

  const { email } = settings;

  useEffect(() => {
    if (email)
      try {
        const docs = projectFirestore.collection("users").doc(`${email}`).collection("settlementInfo").doc("info");

        docs
          .get()
          .then((doc) => {
            if (doc.exists) {
              setData({ ...doc.data(), id: doc.id });
            }
          })
          .catch((error) => {
            console.log("Error getting document:", error);
            BasicAlert(error);
          });
      } catch (error) {
        console.error(error);
      }
  }, []);

  return (
    <div className="border-table">
      <PayInfoForm data={data} />
    </div>
  );
};

/* 디테일 페이지 상단 메뉴 */
const PayInfoForm = ({ data }) => {
  // const settings = useSettings();

  /* 모달 값 저장 */
  const [modalVisible, setModalVisible] = useState(false);

  /* 정산정보 저장 */
  const [myName, setMyName] = useState();
  const [myPhone, setMyPhone] = useState();
  const [myEmail, setMyEmail] = useState();
  const [myBank, setMyBank] = useState();
  const [myBankAccount, setMyBankAccount] = useState();
  const [myDepositor, setMyDepositor] = useState();

  useEffect(() => {
    if (data) {
      const { name, phone, email, bank, bankAccount, depositor } = data;

      /* 기존 정산정보 저장 */
      setMyName(name);
      setMyPhone(phone);
      setMyEmail(email);
      setMyBank(bank);
      setMyBankAccount(bankAccount);
      setMyDepositor(depositor);
    }
  }, [data]);

  /* profile 정보 업데이트 */
  // const handleProfileUpdate = async () => {
  //   // 전화번호 유효성 체크
  //   if (!PhoneNumberValidator(myPhone)) {
  //     BasicAlert("전화번호를 다시 입력해주세요.");
  //     return;
  //   }

  //   if (!myName || myName === "" || !myPhone || myPhone === "" || !myEmail || myEmail === "") {
  //     BasicAlert("정산 신청자 정보를 입력해주세요.");
  //     return;
  //   }

  //   if (!CheckEmail(myEmail)) {
  //     BasicAlert("이메일이 유효하지 않습니다.");
  //     return;
  //   }

  //   if (!myDepositor || myDepositor === "" || !myBank || myBank === "" || !myBankAccount || myBankAccount === "") {
  //     BasicAlert("입금 계좌 정보를 입력해주세요.");
  //     return;
  //   }

  //   /* 공백 제거 */
  //   const replaceMyName = myName.replace(/(\s*)/g, "");
  //   const replaceMyPhone = myPhone.replace(/(\s*)/g, "");
  //   const replaceMyEmail = myEmail.replace(/(\s*)/g, "");
  //   const replaceMyBank = myBank.replace(/(\s*)/g, "");
  //   const replaceMyBankAccount = myBankAccount.replace(/(\s*)/g, "");
  //   const replaceMyDepositor = myDepositor.replace(/(\s*)/g, "");

  //   const updateValue = {
  //     name: replaceMyName,
  //     phone: replaceMyPhone,
  //     email: replaceMyEmail,
  //     bank: replaceMyBank,
  //     bankAccount: replaceMyBankAccount,
  //     depositor: replaceMyDepositor,
  //   };

  //   /* 프로필 정보 업데이트 */
  //   try {
  //     const docRef = projectFirestore.collection("users").doc(`${settings.email}`).collection("settlementInfo").doc("info");

  //     await docRef.set(updateValue).then(() => {
  //       const text = "적용되었습니다.";
  //       SuccessAlert(text);
  //       return;
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // Modal
  const closeModal = () => {
    setModalVisible(false);
  };

  const handleModalOkButton = () => {
    setModalVisible(false);
    handlePayInfoUpdate();
  };

  return (
    <div className="lg:px-40 xl:px-52">
      {/* 신청자 정보 */}
      <div>
        <div className="border-b border-ddd pb-2">
          <h4 className="text-base mb-0">정산 신청자 정보</h4>
          <p className="text-888 text-xs mb-0">정보를 클릭하면 수정이 가능합니다.</p>
        </div>
        <div className="my-3">
          {/* 이름 */}
          <TextField
            label="이름"
            placeholder="실명 입력"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            className="my-3"
            value={myName || ""}
            onChange={(e) => setMyName(e.target.value)}
          />
        </div>
        <div className="my-3">
          {/* 전화번호 */}
          <TextMaskCustom myPhone={myPhone} setMyPhone={setMyPhone} />
        </div>
        <div className="my-3">
          {/* E-Mail */}
          <TextField
            label="e-mail"
            placeholder="이메일"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            className="my-3 mr-3"
            value={myEmail || ""}
            onChange={(e) => setMyEmail(e.target.value)}
          />
        </div>
      </div>

      {/* 입금 계좌 설정 */}
      <div className="mt-5">
        <div className="border-b border-ddd pb-2">
          <h4 className="text-base mb-0">입금 계좌 설정</h4>
          <p className="text-888 text-xs mb-0">정산 받을 계좌를 설정해 주세요</p>
        </div>
        <div className="my-3">
          {/* 예금주 */}
          <TextField
            label="예금주"
            placeholder="예금주 입력"
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            className="my-3"
            value={myDepositor || ""}
            onChange={(e) => setMyDepositor(e.target.value)}
          />
        </div>
        <div className="my-3">
          {/* 계좌번호 */}
          <BankAccountNumber myBankAccount={myBankAccount} setMyBankAccount={setMyBankAccount} />
        </div>
        <div className="my-3">
          <FormControl className="my-3 mr-3 w-full">
            <InputLabel shrink id="demo-simple-select-placeholder-label-label">
              은행 선택
            </InputLabel>
            <Select
              native
              value={myBank || ""}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              onChange={(e) => setMyBank(e.target.value)}
            >
              <option value={"KB국민은행"}>KB국민은행</option>
              <option value={"신한은행"}>신한은행</option>
              <option value={"우리은행"}>우리은행</option>
              <option value={"하나은행"}>하나은행</option>
              <option value={"케이뱅크"}>케이뱅크</option>
              <option value={"카카오뱅크"}>카카오뱅크</option>
              <option value={"한국산업은행"}>한국산업은행</option>
              <option value={"중소기업은행"}>중소기업은행</option>
              <option value={"한국수출입은행"}>한국수출입은행</option>
              <option value={"NH농협은행"}>NH농협은행</option>
              <option value={"수협은행"}>수협은행</option>
              <option value={"대구은행"}>대구은행</option>
              <option value={"부산은행"}>부산은행</option>
              <option value={"경남은행"}>경남은행</option>
              <option value={"광주은행"}>광주은행</option>
              <option value={"전북은행"}>전북은행</option>
              <option value={"제주은행"}>제주은행</option>
              <option value={"한국씨티은행"}>한국씨티은행</option>
              {/* MenuItem */}
            </Select>
          </FormControl>
        </div>
      </div>

      {/* 정보 변경 */}
      <div className="center">
        <button className="btn glass_in_btn" onClick={() => setModalVisible(true)}>
          적용하기
        </button>
      </div>
      {/* 모달 */}
      <Modal visible={modalVisible} width="400" height="210" effect="fadeInUp" onClickAway={() => closeModal()}>
        <div className="aiso-modal">
          <div className="aiso-modal-header">
            <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible(false)}>
              <i className="ti-close font-bold"></i>
            </button>
          </div>
          <div className="aiso-modal-body text-center">
            <h3 className="text-xl font-bold text-primary mb-0" id="modal-title">
              적용 하시겠습니까?
            </h3>
            <div className="mt-2">
              <p className="text-xs text-gray-500">적용을 원하시면 확인 버튼을 눌러주세요.</p>
            </div>
          </div>
          <div className="aiso-modal-footer text-center">
            <button type="button" className="btn btn-modal-o w-1/3" onClick={() => handleModalOkButton()}>
              확인
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PayInfo;
